import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const gantt: ThemeUICSSObject = {
  'div div._3eULf ._25P-K': {
    backgroundColor: 'white',
    padding: '10px',
    height: 'auto',
    width: 'auto',
    // borderRadius: '10px',
    boxShadow: '2px 2px 2px 2px rgb(0 0 0 / 30%)',
    zIndex: '10',
    position: 'absolute',
    top: '0 !important',
    right: '0 !important',
    left: 'auto !important',
  },
  '.taskGantt__Timeline': {
    display: 'block',
    marginTop: '10px',
  },
  '.taskGanttToolTip__SmallText': {
    color: 'grey',
    fontSize: '0.8em',
  },
  '.taskGanttToolTip__Title': {
    // backgroundColor: 'lightgrey',
    display: 'flex',
    justifyContent: 'center',
    // borderRadius: '10px 10px 0 0',
    backgroundColor: 'palette.secondary.main',
    color: 'palette.secondary.contrastText',
  },
  g: {
    'text._3zRJQ': {
      fill: 'white',
      fontWeight: 600,
    },
    '._KxSXS': {
      g: {
        rect: {
          '&._31ERP': {
            '& ~ rect': {
              fill: 'gantt.fillColor.fill',
            },
            fill: 'gantt.emptyColor.fill',
          },
        },
      },
    },
    '&._1KJ6x': {
      rect: {
        fill: 'gantt.fillColor.fill',
        '&._2RbVy': {
          fill: 'gantt.emptyColor.fill',
        },
      },
      'polygon._2pZMF, rect._2pZMF': {
        fill: 'gantt.borderColor.fill',
      },
    },
  },
};

export default gantt;
